import { render, staticRenderFns } from "./client-templates.vue?vue&type=template&id=66e20dc7&scoped=true"
import script from "./client-templates.vue?vue&type=script&lang=js"
export * from "./client-templates.vue?vue&type=script&lang=js"
import style0 from "./client-templates.vue?vue&type=style&index=0&id=66e20dc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e20dc7",
  null
  
)

export default component.exports